import type { ModalDialogProps } from '@atlaskit/modal-dialog';

export const MODAL_CONFIG: ModalDialogProps = {
	width: 'x-large',
	shouldScrollInViewport: true,
};

export const SERVICE_COLLECTION_PRICING_PAGE_URL =
	'https://www.atlassian.com/collections/service/pricing';

/** Admin billing (subscription management); used for “cancel anytime” in standard benefits modal when payment details are on file. */
export const ADMIN_BILLING_PATH = '/admin/billing';

export const STORAGE_MANAGEMENT_PATH =
	'/jira/settings/products/jira-service-desk-configuration/storage-management';

/** SAC page for cancelling a subscription; linked from the "cancel anytime" anchor in the standard benefits billing section. */
export const CANCEL_SUBSCRIPTION_SAC_URL =
	'https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/';

export const JSM_PRICING_PAGE_URL =
	'http://www.atlassian.com/software/jira/service-management/product-pricing';

export const INCIDENTS_SLACK_INTEGRATION_VIDEO_URL = `https://www.youtube.com/embed/cljyGRFV2fo?rel=0&modestbranding=1`;

/** Activation UUID for the OOTB "Support Companion" Rovo agent (csm_support_copilot_agent). */
export const SUPPORT_COMPANION_AGENT_ID = '0ce0f1da-1c46-4bff-9a32-d1128cfbca68';
